<template>
  <div>
    <loginAndOtherComponent></loginAndOtherComponent>
    <!-- 解析模板接口内容部分 -->
    <div class="introduction">
      <div class="breadCrumbs-box">
        <span class="breadCrumbs cursor" @click="$router.push('/login')">首页</span>
        <i class="el-icon-arrow-right" style="padding: 0 16px"></i>
        <template v-for="(item,index) in breadCrumbs">
          <i class="el-icon-arrow-right" style="padding: 0 16px" v-if="index"></i>
          <span class="breadCrumbs cursor" :class="[(index == (breadCrumbs.length -1)) ? 'red' : '']" @click="goUrl(item)">{{ item.name  }}</span>
        </template>
      </div>
        <div class="innerList" v-if="type != 'list'">
          <div class="inner-title" v-html="title"></div>
          <div class="inner-title-bottom">
            <div style="width:40%"><el-divider></el-divider></div>
          </div>
          <div v-html="item[0] && item[0].contentText" id="contentText"></div>
        </div>
        <div v-else >
          <div class="innerList">
            <div v-for="(item,index) in item" class="inner-box cursor" @click="goDetail(item)">
              <div class="line" v-if="index"></div>
              <img class="user-img" :src="item.contentUrl" alt="">
              <div class="info">
                <div class="title">{{item.title}}</div>
                <div class="contentSummary">{{item.contentSummary}}</div>
              </div>
            </div>
          </div>
          <paginationComponent class="pagination" :currentPage="page"  :pageSize="pageNum" :total="total" @currentChange="currentChange" ></paginationComponent>
      </div>
    </div>
    <copyBottom></copyBottom>
  </div>
</template>

<script>
import paginationComponent from '@components/paginationComponent/paginationComponent';
import loginAndOtherComponent from './loginNewCompone/loginAndOtherComponent';
import copyBottom from './loginNewCompone/copyBottom';

export default {
  name: 'introduction',
  components: {
    loginAndOtherComponent,
    copyBottom,
    paginationComponent,
  },
  data() {
    return {
      name: '',
      id: '',
      page: 1,
      pageNum: 5,
      total: 5,
      type: '',
      itemStr: undefined,
      item: [],
      title: '',
      breadCrumbs: [],
    };
  },
  watch: {
    '$route.query': {
      handler(value) {
        if (value.id) {
          this.updateThis(value);
        }
      },
      immediate: true,
      deep: true,
    },
    item: {
      handler(value) {
        if (value.length < 2) {
          // 如果 item 存在表明是 列表来到详情
          this.$nextTick(() => {
            // 存在可编辑富文本情况下
            if (document.querySelector('#contentText')) {
              const zipImg = document.querySelector('#contentText').querySelectorAll('.downImgEditor');
              for (let i = 0; i < zipImg.length; i++) {
                const a = document.createElement('a');
                const img = zipImg[i];
                let downUrl = img.previousSibling.innerHTML; const url = downUrl;
                downUrl = downUrl.split('/');
                a.setAttribute('href', img.previousSibling.innerHTML);
                a.innerHTML = downUrl[downUrl.length - 1];
                const suffix = url.substr(url.lastIndexOf('.') + 1);
                img.setAttribute('onclick', `downUpload(this,'${suffix}','${img.previousSibling.innerHTML}')`);
                img.setAttribute('class', 'cursor');
                img.setAttribute('alt', '点击下载该附件');
                if (suffix != 'jpg' && suffix != 'png') {
                  img.parentNode.insertBefore(a, img);
                }
              }
            }
          });
        }
      },
    },
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
    }
  },
  methods: {
    goUrl(item) {
      console.log(item);
      if (!item.query.item) {
        this.$router.push({ path: '', query: item.query });
      }
    },
    currentChange(val) {
      this.page = val;
      this.updateThis({ id: this.id, name: this.name });
    },
    updateThis(value) {
      this.breadCrumbs = [];
      this.id = value.id;
      this.name = value.name;
      this.breadCrumbs.push({ name: this.name, query: { id: this.id, name: this.name } });
      if (value.item) {
        const contentText = window.LS.get('contentText');
        this.itemStr = window.LS.get('title');
        this.item = [{
          contentText,
        }];
        // 手动将 展示类型切换为 文本
        this.type = 'text';
        this.breadCrumbs.push({ name: this.itemStr, query: this.$route.query });
        window.LS.remove('contentText');
        window.LS.remove('title');
        return false;
      }
      window.$axios.post('/ebopo/api/content/getInfoByType', {
        contentTypeId: value.id,
        page: this.page,
        pageNum: this.pageNum,
      })
        .then((res) => {
          res = res.data;
          if (!res.code) {
            this.type = res.data.type;
            this.item = res.data.info.list;
            this.total = res.data.info.total;
            this.title = res.data.info.list[0].title;
          }
        });
    },
    goDetail(item) {
      window.LS.set('contentText', item.contentText);
      window.LS.set('title', item.title);
      this.title = item.title;
      this.$router.push({
        path: '/introduction',
        query: {
          id: this.id,
          name: this.name,
          item: 'sure',
        },
      });
    },
  },
};
</script>

<style scoped lang="stylus">
width = 1200px
/deep/.header_component {
  width: 100%
  box-shadow: 0px 5px 15px 0px rgba(22, 135, 255, 0.1);
  .header_info {
    width width ;
    margin: 0 auto
  }
}
.introduction {
  width width ;
  margin: 0 auto
  .breadCrumbs-box {
    width: 100%
    padding 33px 0
  }
  .breadCrumbs {
    width: 32px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;

    &.red {
      color: #E60020;
    }
  }
}
.innerList {
  width: width
  height: auto
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 2px #E2EBF3;
  border-radius: 18px;
  padding 40px 32px
  box-sizing border-box
}
.inner-title{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 32px;
    text-align: center;
}

.inner-title-bottom{
  display flex
  width 100%
  justify-content: center
}
.inner-title-bottom-text{
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #999999;
  line-height: 32px;
}
.inner-box {
  width: 100%
  height: auto
  padding 0 0 20px 0;
  box-sizing border-box
  overflow hidden
}
.user-img {
  width: 200px;
  height: 120px;
  border-radius: 8px;
  display block
  float: left
}
.info {
  width: 882px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
  float: left
  margin-left 32px
  .title {
    width: 100%;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #FFB300;
  }
  .contentSummary {
    margin-top 9px
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; //作为弹性伸缩盒子模型显示。
    -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
    -webkit-line-clamp: 4; //显示的行
  }
}
.line {
  width: 1144px;
  margin 0 auto 20px;
  height: 1px;
  background: #EEEEEE;
}
.pagination {
  padding-top 25px
  text-align center
}
</style>
